/* import __COLOCATED_TEMPLATE__ from './user-dropdown.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type SessionService from 'dashboard/services/-session';
import type CurrentUserService from 'dashboard/services/current-user';
import type AnalyticsService from 'dashboard/services/analytics';

interface UserDropdownSignature {
  Element: HTMLDivElement;
  Args: {
    isOpen: boolean;
    shouldLockFocus: boolean;
    open(): void;
    close(): void;
    didTransitionIn(): void;
  };
  Blocks: { default: [] };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    UserDropdown: typeof UserDropdown;
  }
}

export default class UserDropdown extends Component<UserDropdownSignature> {
  @service declare session: SessionService;
  @service declare currentUser: CurrentUserService;
  @service declare analytics: AnalyticsService;

  @action handleLogoutClick(): void {
    this.analytics.track('user_profile__logout');
    this.session.invalidate();
  }
}
